import { orderTypeguard } from "~/components/ordering/order-page/utils/";
import { cartTypeguard } from "~/components/ordering/checkout/utils/typeguard";

export const typeguard = {
  order: orderTypeguard,
  cart: cartTypeguard,
}